<style>
#login {
    background: url("../../assets/backImage/xiaoxian_bg.jpg") no-repeat;
    background-size: 100% 100%;
}

.center {
    text-align: center;
}

col {
    background: #fff;
    padding: 60px 60px 20px 60px;
    border-radius: 10px;
}

#login_top {
    width: 100%;
    height: 130px;
    line-height: 130px;
    background: url("../../assets/backImage/xiaoxian_login.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    font-size: 34px;
}

#login_form {
    background: #fff;
    padding-top: 30px;
    padding-bottom: 10px;
    border-radius: 0 0 6px 6px;
    margin-top: 0;
}

input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 400px #e8eced inset;
}
</style>
<template>
<Row type="flex" justify="center" align="middle" id="login">
    <Col span="5" style="min-width:320px">
    <div id="login_top">小 罐 茶 后 台 管 理</div>
    <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="top" id="login_form">
        <FormItem prop="user" style="width:60%;margin:0 auto">
            <Input type="text" v-model="formInline.user" placeholder="请输入账号">
            <Icon type="ios-person-outline" slot="prepend" color="#fc0a43" size="22"></Icon>
            </Input>
        </FormItem>
        <FormItem prop="password" style="width:60%;margin:22px auto 0px">
            <Input type="password" v-model="formInline.password" placeholder="请输入密码" @on-enter="handleSubmit('formInline')">
            <Icon type="md-keypad" slot="prepend" color="#fc0a43" size="18"></Icon>
            </Input>
        </FormItem>
        <FormItem style="width:60%;margin:14px auto 0px">
            <!-- <Checkbox v-model="single">记住密码</Checkbox> -->
        </FormItem>
        <FormItem class="center" style="width:20%;margin:0px auto 12px;">
            <Button type="primary" @click="handleSubmit('formInline')" style="background-color:#fc0a43; border-color:#fc0a43;" shape="circle" long>登录</Button>
        </FormItem>
    </Form>
    </Col>
</Row>
</template>

<script>
export default {
    data() {
        return {
            single: !!(localStorage.getItem('tel') && localStorage.getItem('pwd')),
            username: '',
            formInline: {
                user: localStorage.getItem('tel') || '',
                password: localStorage.getItem('pwd') || ''
            },
            ruleInline: {
                user: [{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur'
                }],
                password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                    {
                        type: 'string',
                        min: 1,
                        message: '密码不能为空哦！',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        handleSubmit(name) {
            const self = this;
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$axios.post('/weixin/admin/login', {
                        username: this.formInline.user,
                        password: this.formInline.password
                    }).then(res => {
                      console.log(res)
                      if(res.data.code === 0) {
                        let token = res.data.data.token
                        localStorage.setItem('token', token)
                        self.$Message.success('登录成功咯');
                        self.$router.push({ path: '/BackHome' });
                        // sessionStorage.setItem('active',1)
                        sessionStorage.clear()
                      }else {
                        self.$Message.error('登录失败咯');
                      }
                    })
                    // self.$Message.success('登录成功咯');
                    // self.$router.push({ path: '/BackHome' });
                }
            });
        }
    }
};
</script>
